import * as Sentry from '@sentry/react';
import React from 'react';

import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';

import { ToastContainer } from 'react-toastify';

import Routes from './routes';
import { store, persistor } from './store';

import GlobalStyles from './styles/global';
import '~/assets/icons/fontello.css';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0384AC',
    },
    secondary: {
      main: '#f48fb1',
    },
  },
});

function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <Routes />
            <GlobalStyles />
            <ToastContainer autoClose={3000} />
          </BrowserRouter>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
}

export default Sentry.withErrorBoundary(App, {
  fallback: <p>Algo deu errado. Tente recarregar a página.</p>,
});
